import { notificationsServiceBaseUrl } from "@coworker/app/src/core/cloud-services/cloud-services.helper";
import { isChineseEnvironment } from "@coworker/reusable/helpers/devices";
import { getEnvironmentId } from "@coworker/reusable/helpers/environment";

const isChina = isChineseEnvironment();

export const NOTIFICATIONS_SERVICE_URL = notificationsServiceBaseUrl(
  getEnvironmentId(),
  isChina
);
